var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurantsInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1313 6.58342L33.1351 6.58484C33.3544 6.66707 33.5 6.87698 33.5 7.11144V9.5625C33.5 9.87339 33.2484 10.125 32.9375 10.125H1.0625C0.751611 10.125 0.5 9.87339 0.5 9.5625V7.11148C0.5 7.11147 0.5 7.11146 0.5 7.11144C0.500016 6.99696 0.534959 6.88521 0.600162 6.79111C0.665372 6.697 0.757744 6.62503 0.864942 6.58481L0.864948 6.58483L0.868648 6.5834L16.43 0.60355C16.4306 0.603347 16.4311 0.603143 16.4317 0.60294C16.7983 0.465692 17.2023 0.465687 17.569 0.602925C17.5695 0.603133 17.5701 0.603342 17.5706 0.60355L33.1313 6.58342ZM4.25 23.875H4.75V23.375V13.25H8V23.375V23.875H8.5H14.875H15.375V23.375V13.25H18.625V23.375V23.875H19.125H25.5H26V23.375V13.25H29.25V23.375V23.875H29.75H30.8125C31.1234 23.875 31.375 24.1266 31.375 24.4375V27.125H2.625V24.4375C2.625 24.1266 2.87661 23.875 3.1875 23.875H4.25ZM1.0625 30.25H32.9375C33.2484 30.25 33.5 30.5016 33.5 30.8125V32.9375C33.5 33.2484 33.2484 33.5 32.9375 33.5H1.0625C0.751612 33.5 0.5 33.2484 0.5 32.9375V30.8125C0.5 30.5016 0.751611 30.25 1.0625 30.25Z",
    fill: "white",
    stroke: "#3C4469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantsInActive);
export default __webpack_public_path__ + "static/media/Restaurants-InActive.14b0f041d7171037fcfda577c432aba9.svg";
export { ForwardRef as ReactComponent };